import Button from "sap/m/Button";
import DatePicker from "sap/m/DatePicker";
import HBox from "sap/m/HBox";
import Input from "sap/m/Input";
import DateTime from "sap/mcsuite/model/ts/formats/DateTime";
import Control, { $ControlSettings } from "sap/ui/core/Control";
import { MetadataOptions } from "sap/ui/core/Element";
import RenderManager from "sap/ui/core/RenderManager";

type $DateTimePickerSettings = $ControlSettings & {
    value?: Date;
    intervalMinutes?: number;
};

export default class DateTimePicker extends Control {
    constructor(idOrSettings?: string | $DateTimePickerSettings);
	constructor(id?: string, settings?: $DateTimePickerSettings);
	constructor(id?: string, settings?: $DateTimePickerSettings) { super(id, settings); }

    private _container: HBox;
    private _datePicker: DatePicker;
    private _timeContainer: HBox;
    private _addTimeButton: Button;
    private _reduceTimeButton: Button;
    private _timeInput: Input;
    private readonly dateFormatter: DateTime = new DateTime();
    
    static readonly metadata: MetadataOptions = {
        properties: {
            value: { type: "object", defaultValue: new Date() },
            intervalMinutes: { type: "int", defaultValue: 15 }
        }
    };
    init(): void {
        this._container = new HBox({id: this.getId() + "-container", justifyContent: "Start", alignItems: "Center"});
        this._timeContainer = new HBox({ justifyContent: "Center", alignItems: "Center"});
        this._datePicker = new DatePicker();
        this._timeInput = new Input({ width: "4rem" });
        this._addTimeButton = new Button({ 
            icon: "sap-icon://fa-light/plus", 
            press: this._onAddTime.bind(this),
            width: "2rem"
        });
        this._reduceTimeButton = new Button({ 
            icon: "sap-icon://fa-light/minus", 
            press: this._onReduceTime.bind(this),
            width: "2rem"
        });

        this._timeContainer.addItem(this._reduceTimeButton);
        this._timeContainer.addItem(this._timeInput);
        this._timeContainer.addItem(this._addTimeButton);

        this._container.addItem(this._datePicker);
        this._container.addItem(this._timeContainer);
    }

    private _onAddTime(): void {
        const timeString = this._timeInput.getValue();
        var time = this.dateFormatter.parseValue(timeString);

        if (time) {
            time.setMinutes(time.getMinutes() + this.getIntervalMinutes());
            this.dateFormatter.formatValue(time);
        }
        this._timeInput.setValue(this.dateFormatter.formatValue(time));
    }

    private _onReduceTime(): void {
        const timeString = this._timeInput.getValue();
        var time = this.dateFormatter.parseValue(timeString);
        if (time) {
            time.setMinutes(time.getMinutes() - this.getIntervalMinutes());
            this.dateFormatter.formatValue(time);
        }
        this._timeInput.setValue(this.dateFormatter.formatValue(time));
    }

    getIntervalMinutes(): number {
        return this.getProperty("intervalMinutes");
    }

    getValue(): Date {
        const date = this._datePicker.getDateValue();
        const timeString = this._timeInput.getValue();
        const time = this.dateFormatter.parseValue(timeString);
        if (date && time) {
            date.setHours(time.getHours());
            date.setMinutes(time.getMinutes());
            date.setSeconds(0);
            date.setMilliseconds(0);
            return date;
        }
        return new Date();
    }

    setValue(value: Date): this {
        this.setProperty("value", value);
        this._datePicker.setDateValue(value);
        this._timeInput.setValue(this.dateFormatter.formatValue(value));
        return this;
    }
    static renderer = {
        apiVersion: 4,
        render: function(oRM: RenderManager, oControl: DateTimePicker): void {
            oRM.openStart("div", oControl);
            oRM["class"]("mc-datetime-picker");
            oRM.openEnd();
            oRM.renderControl(oControl._container as Control);
            oRM.close("div");
        }
    }
}

